import React, { useEffect, useState } from "react";
import { API } from "../../API";
import './Invoice.css';
import CollegePageContainer from "../Container/CollegePageContainer";
import Spinner from '../../Components/Spinner/Spinner';
import { notify } from "react-notify-toast";
import ModalComponent from "../../Components/Modal/Modal";
import FormDropdown from "../../Components/FormField/FormDropdown";
import { invoiceBookingFees, invoiceBookingFeesReason, invoiceVariationReasons } from "../Bookings2/Helper";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import moment from "moment/moment";
import { APIMETHOD } from "../../v2/API";
import { customer } from "../../v2/endpoints/customer";
import { IconButton } from "@mui/material";
import QualificationLevelModal from "./QualificationLevelModal";
import ModeIcon from '@mui/icons-material/Mode';
import { useHistory } from 'react-router-dom';

export default function InvoiceViewerComponent(props) {
    const history = useHistory();

    const user = JSON.parse(JSON.parse(window.localStorage['persist:root']).college)?.user;
    const institution = JSON.parse(JSON.parse(window.localStorage['persist:root']).college).institution;
    const managerPersonnel = JSON.parse(JSON.parse(window.localStorage['persist:root']).college)?.personnel?.filter(item => {
        if (item?.access_permission?.manage_payment || item?.access_permission?.receive_invoice_copy) {
            return item.personnel_first_name + ' ' + item.personnel_last_name;
        }
    });

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [subTotal, setSubTotal] = useState(0);
    const [totalGST, setTotalGST] = useState(0);
    const [editingIndex, setEditingIndex] = useState(-1);
    const [status, setStatus] = useState("Under review by RT admin");
    const [commentRevision, setCommentRevision] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [totalReasons, setTotalReasons] = useState(0);
    const [invoiceData, setInvoiceData] = useState('');
    const [invoiceId, setInvoiceId] = useState(props.match.params.id);
    const [editedStatus, setEditedStatus] = useState(false);
    const [isOpenPopupApproved, setIsOpenPopupApproved] = useState(false);
    const [isDisabledButton, setIsDisabledButton] = useState(false);
    const [qualifications, setQualifications] = useState(false);
    const [isQualificationsOpen, setIsQualificationsOpen] = useState(false);
    const [dateBookingIndex, setDateBookingIndex] = useState(-1);
    const [levelItems, setLevelItems] = useState("");
    const [originalData, setOriginalData] = useState(null);

    useEffect(() => {
        API.getInvoiceDataForCollege(invoiceId)
            .then(result => {
                setIsLoading(false);
                let content = [];
                let invoice = result?.data?.result;
                let countReasons = 0;
                content = invoice?.content || [];
                setData(content);
                let personnel_id = user?.personnel_id ?? "";
                invoice.pn_view = true;
                if (invoice?.institution?.split_campuses) {
                    // Loop through each item in split_campuses
                    invoice.institution.split_campuses.forEach(item => {
                        // Check if approvers include personnel_id
                        if (item.approvers.includes(personnel_id)) {
                            // Loop through each campus in item.campuses
                            item.campuses.forEach(campus => {
                                // Check if invoice.campuses includes campus
                                if (invoice?.campuses.includes(campus)) {
                                    // If included, set pn_view to true
                                    invoice.pn_view = false;
                                }
                            });
                        }
                    });
                }
                setInvoiceData(invoice);
                setCommentRevision(invoice?.comment || '');
                let subTotalItem = 0;
                let totalGSTItem = 0;
                content.map(item => {
                    subTotalItem += item.unit_amount * item.quantity - (item?.discount ? (item.unit_amount * item.quantity) * item?.discount / 100 : 0);
                    totalGSTItem += item.tax_type === 'GST on income' ? (item.unit_amount * item.quantity * 10) / 100 : 0;
                    if (item?.reason && item?.reason !== '') {
                        countReasons += 1;
                    }
                })

                let is_edit = content.filter(item => {
                    if (item.is_edit?.quantity == true || item.is_edit?.description == true) {
                        return true;
                    }
                }) || [];

                if (is_edit.length > 0) {
                    setEditedStatus(true);
                } else {
                    setEditedStatus(false);
                }

                if (countReasons > 0) {
                    setTotalReasons(countReasons);
                }
                calculatePrice(subTotalItem, totalGSTItem);
                if (result?.data.result?.status) {
                    setStatus(result.data.result?.status);
                }
            });
        API.getQualificationList().then(result => {
            setQualifications(result.data.data);
        });
    }, []);

    const handleEditingMode = (index) => {
        setEditingIndex(index);
        // Store the original data for this item to restore on cancel
        setOriginalData({
            index: index,
            data: JSON.parse(JSON.stringify(data[index]))
        });
    }

    const calculatePrice = (subTotalItem, totalGSTItem) => {
        subTotalItem = Math.floor(subTotalItem * 100) / 100;
        totalGSTItem = Math.floor(totalGSTItem * 100) / 100;
        setSubTotal(subTotalItem);
        setTotalGST(totalGSTItem);
    }

    const handleCalculatePriceInvoice = (data) => {
        let subTotalItem = 0;
        let totalGSTItem = 0;
        data.map(item => {
            subTotalItem += item.unit_amount * item.quantity - (item?.discount ? (item.unit_amount * item.quantity) * item?.discount / 100 : 0);
            totalGSTItem += item.tax_type === 'GST on income' ? (item.unit_amount * item.quantity * 10) / 100 : 0;
        });
        calculatePrice(subTotalItem, totalGSTItem);
    }

    const handleUpdateMode = async (index) => {
        setEditingIndex(-1);
        
        // Check if any actual changes were made to the item
        const currentItem = data[index];
        const hasChanges = currentItem.is_edit?.description === true || 
                          currentItem.is_edit?.quantity === true || 
                          currentItem.is_edit?.reason === true;
        
        // Only proceed with API call if there are actual changes
        if (hasChanges) {
            setEditedStatus(true);
            setStatus('Under review by RT admin');
            const dataContent = [...data];
            dataContent[index].comment_by_admin.status = "";
            const invoiceData = {
                content: dataContent,
                amount: subTotal + totalGST,
                status: 'Under review by RT admin',
                comment: commentRevision,
            }
            await API.updateInvoiceForCustomer(invoiceId, invoiceData);
        }
    }

    const handleCancelEdit = () => {
        if (originalData) {
            // Restore the original data for the edited item
            const newData = [...data];
            newData[originalData.index] = originalData.data;
            setData(newData);
            
            // Recalculate prices with restored data
            handleCalculatePriceInvoice(newData);
        }
        
        setEditingIndex(-1);
        setOriginalData(null);
        setEditedStatus(false);
    }

    const handleAddComment = async () => {
        setStatus('Under review by RT admin');
        const invoiceData = {
            content: data,
            amount: subTotal + totalGST,
            status: 'Under review by RT admin',
            comment: commentRevision
        }
        const invoice = await API.updateInvoiceForCustomer(invoiceId, invoiceData);
        setCommentRevision(invoice.comment);
        notify.show("Add comment successfully");
    }

    const changeFromDate = (date, index) => {
        const preState = [...data];
        let object = { ...preState[editingIndex] };
        object.dateBookings[index].startDate = moment(date, "DD-MM-YY").format("DD-MM-YY");
        object.is_edit.description = true;
        preState[editingIndex] = object;
        setData(preState);
    };

    const changeToDate = (date, index) => {
        const preState = [...data];
        let object = { ...preState[editingIndex] };
        object.dateBookings[index].endDate = moment(date, "DD-MM-YY").format("DD-MM-YY");
        object.is_edit.description = true;
        preState[editingIndex] = object;
        setData(preState);
    };

    const handleMarkAsDone = async (index) => {
        const preState = [...data];
        let object = { ...preState[index] };
        object.mark_as_done = true;
        object.is_edit.description = false;
        object.is_edit.quantity = false;
        preState[index] = object;
        setData(preState);
        const invoiceData = {
            content: preState,
            amount: subTotal + totalGST,
            comment: commentRevision
        }
        await API.updateInvoiceForCustomer(invoiceId, invoiceData, true);
    }

    const handleApprove = async () => {
        setStatus('Approved by customer');
        const invoiceData = {
            status: 'Approved by customer'
        }
        setIsOpenPopupApproved(false);
        await API.updateInvoiceForCustomer(invoiceId, invoiceData);
        window.open('https://pay.b2bpay.com.au/REDYTEACH', '_blank');
    }

    const handleClickPrevOrNextButton = (is_next) => {
        setIsLoading(true);
        setEditingIndex(-1);
        APIMETHOD.get(`${customer.invoicePreviousOrNext}/${invoiceData?._id}`, {
            customer_id: user?.customer_id || user?.personnel_id,
            is_next: is_next
        }).then(result => {
            if (result?.data?.content) {
                setIsLoading(false);
                let invoice = [];
                let countReasons = 0;
                invoice = result?.data?.content || [];
                setData(invoice);
                setInvoiceData(result?.data);
                setInvoiceId(result?.data?._id)
                setCommentRevision(result?.data?.comment || '');
                let subTotalItem = 0;
                let totalGSTItem = 0;
                invoice.map(item => {
                    subTotalItem += item.unit_amount * item.quantity - (item?.discount ? (item.unit_amount * item.quantity) * item?.discount / 100 : 0);
                    totalGSTItem += item.tax_type === 'GST on income' ? (item.unit_amount * item.quantity * 10) / 100 : 0;
                    if (item?.reason && item?.reason !== '') {
                        countReasons += 1;
                    }
                })

                let is_edit = invoice.filter(item => {
                    if (item.is_edit?.quantity == true || item.is_edit?.description == true) {
                        return true;
                    }
                }) || [];

                if (is_edit.length > 0) {
                    setEditedStatus(true);
                } else {
                    setEditedStatus(false);
                }

                if (countReasons > 0) {
                    setTotalReasons(countReasons);
                }
                calculatePrice(subTotalItem, totalGSTItem);
                if (result?.data.status) {
                    setStatus(result.data.status);
                }
            } else {
                setIsLoading(false);
                if (is_next == true) {
                    notify.show(`It's a last invoice.`);
                } else {
                    notify.show(`It's a first invoice.`);
                }
            }
        });
    }

    const addRow = (current_index, item) => {
        let newData = [
            {
                description: `${item.first_name} Non-Teaching Services ${item.suburb_code} `,
                dateBookings: item.dateBookings,
                comment_by_admin: {},
                quantity: 0,
                unit_amount: 40.00,
                tax_type: "GST Free",
                preCode: item.preCode,
                account_code: "223-3Q",
                itemNumber: item.itemNumber,
                is_edit: {
                    description: false,
                    quantity: false,
                    reason: false
                },
                non_teaching: true,
                college_name: item.college_name,
                contact_name: item.contact_name,
                dateBookings: item.dateBookings
            },
            {
                description: `${item.first_name} Super Non-Teaching Rate`,
                dateBookings: [],
                comment_by_admin: {},
                quantity: 0,
                unit_amount: 3.63,
                tax_type: "GST Free",
                preCode: "",
                account_code: "201",
                itemNumber: item.itemNumber,
                is_edit: {
                    description: false,
                    quantity: false,
                    reason: false
                },
                non_teaching: true,
            }
        ]

        setData([...data.slice(0, current_index + 1), ...newData, ...data.slice(current_index + 1)]);
    }

    const handleDownloadPDF = () => {
        setIsDisabledButton(true);
        const link = document.createElement("a");
        link.target = "_blank";
        APIMETHOD.get(`${customer.generateInvoicePDF}/${invoiceData?._id}`, null, 'blob').then((result) => {
            console.log(result);
            const blob = new Blob([result], { type: 'application/pdf' });
            // Create a URL for the blob
            const url = window.URL.createObjectURL(blob);

            // Create a link to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.download = `${invoiceData.customer?.first_name + '-' + invoiceData.customer?.last_name + '-' + invoiceData?.invoice_number}-invoice.pdf`; // Set the desired filename
            document.body.appendChild(link);

            // Trigger the download
            link.click();

            // Clean up
            window.URL.revokeObjectURL(url);
            setIsDisabledButton(false);
        });
    }

    const handlePopupLevel = (index, level) => {
        setDateBookingIndex(index);
        setLevelItems(level);
        setIsQualificationsOpen(true);
    }

    const changeDescriptionLevel = (value) => {
        const preState = [...data];
        let object = { ...preState[editingIndex] };
        object.dateBookings[dateBookingIndex].levelBooking = value;
        object.is_edit.description = true;
        preState[editingIndex] = object;
        setData(preState);
    }

    const sendEmailToFinances = () => {
        setStatus('Approved by customer');
        const financeIds = managerPersonnel.map(item => item._id);
        API.sendApproveInvoiceToFinance(financeIds, invoiceData._id, invoiceData.invoice_duo_date);
        API.createInvoiceInXero(invoiceData._id);
        setInvoiceData({ ...invoiceData, status: "Approved by customer" });
        setIsOpen(false);
        notify.show("Invoice sent for payment - thank you!");
        history.push('/InvoiceTable');
    }

    return (
        <CollegePageContainer header="Invoice Detail">
            <div className="container bootstrap snippets bootdeys">
                {
                    status ? <div className="invoice-ribbon"><div className={status === 'Paid' ? 'ribbon-inner' : 'ribbon-inner-grey'}>{status}</div></div>
                        : ''
                }
                {
                    isOpen && (<ModalComponent
                        show={true}
                        className="share-profile-modal-new"
                        header="Send Invoice to Finance"
                        onClose={() => {
                            setIsOpen(false)
                        }}
                    >
                        <div className="row">
                            <div className="col-12">
                                <div className="form-field mb-3">
                                    <p>
                                        You are forwarding this approved invoice to { managerPersonnel?.map(item => {
                                            return item.personnel_email;
                                        })?.join(', ')}
                                    </p>
                                    <p className="mt-2 text-info">
                                        <a readOnly={true} target="_blank" href="/Personnel">Change nominated finance officer</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <button onClick={() => setIsOpen(false)} className="btn btn-block secondary-button-no-margin-hover btn-c button-component">Cancel</button>
                            </div>
                            <div className="col-md-6">
                                <button onClick={sendEmailToFinances} className="btn btn-primary btn-block primary-button-no-margin-hover btn-c button-component">Submit</button>
                            </div>
                        </div>
                    </ModalComponent>)
                }

                {
                    isQualificationsOpen && (
                        <QualificationLevelModal levelItems={levelItems} changeDescriptionLevel={changeDescriptionLevel} showPopup={setIsQualificationsOpen} qualifications={qualifications}></QualificationLevelModal>
                    )
                }

                {
                    isOpenPopupApproved && (<ModalComponent
                        show={isOpenPopupApproved}
                        onClose={() => setIsOpenPopupApproved(false)}
                        header="Approve & Pay invoice"
                        className="delete-listing-modal"
                    >
                        <div className="w-100 center-text">
                            Are you sure? This cannot be undone!
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <button onClick={() => setIsOpenPopupApproved(false)} className="btn btn-block secondary-button-no-margin-hover btn-c button-component">Cancel</button>
                            </div>
                            <div className="col-md-6">
                                <button onClick={handleApprove} className="btn btn-primary btn-block primary-button-no-margin-hover btn-c button-component">Approve</button>
                            </div>
                        </div>
                    </ModalComponent>)
                }

                <div className="row">
                    <div className="col-12">
                        <div className="panel panel-default invoice" id="invoice">
                            <div className="panel-body">
                                <div className="row">

                                    <div className="col-12 d-flex justify-content-end">
                                        <p className="p-2">
                                            <button className="btn btn-view">
                                                <a href="/InvoiceTable">View all invoices</a>
                                            </button>
                                        </p>
                                        <div className='mr-3 ml-1 p-2'>
                                            <button
                                                type="button"
                                                className="btn btn-default btn-sm move-day mr-3"
                                                data-action="move-prev"
                                                onClick={() => handleClickPrevOrNextButton(false)}
                                            >
                                                <i
                                                    className="fa fa-arrow-left text-white"
                                                    data-action="move-prev"
                                                />
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-default btn-sm move-day"
                                                data-action="move-next"
                                                onClick={() => handleClickPrevOrNextButton(true)}
                                            >
                                                <i
                                                    className="fa fa-arrow-right text-white"
                                                    data-action="move-next"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-9"></div>
                                    <div className="col-3 d-flex justify-content-center">
                                        <img src="/static/media/logoNew.8950242f.png" alt="logo" className="component-home-logo-profile" role="button" />
                                    </div>
                                </div>

                                <div className="row ml-5 mt-6">
                                    <div className="col-7">
                                        <h1>TAX INVOICE</h1>
                                        <div className="col-5 d-flex flex-column align-items-start">
                                            <div>
                                                <h2>{institution?.institution_name}</h2>
                                            </div>
                                            <div>
                                                <h2>
                                                    {invoiceData?.campuses?.map((item, index) => {
                                                        return <div key={index}>{item.campus_shortname + ', ' + item.suburb}</div>
                                                    })}
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="mt-2">
                                            <h2 className="bold">Invoice Date</h2>
                                            <div>
                                                {moment(invoiceData?.createdAt).tz('Australia/Melbourne').format('DD MMM YYYY')}
                                            </div>
                                        </div>
                                        <div className="mt-2">
                                            <h2 className="bold">Invoice Period</h2>
                                            <div>
                                                {moment(invoiceData?.invoice_period_start_date, 'YYYY-MM-DD').format('DD MMM YYYY')} to {moment(invoiceData?.invoice_period_end_date, 'YYYY-MM-DD').format('DD MMM YYYY')}
                                            </div>
                                        </div>
                                        <div className="mt-2">
                                            <h2 className="bold">Purchase Order</h2>
                                            <div>
                                                {invoiceData?.purchase_order?.po_number ? invoiceData?.purchase_order?.po_number + ' - ' + moment(invoiceData?.purchase_order?.date_of_purchase_order_commencement, 'YYYY-MM-DD').format('DD MMM YYYY') : 'N/A'}
                                            </div>
                                        </div>
                                        <div className="mt-2">
                                            <h2 className="bold">Invoice number</h2>
                                            {invoiceData?.invoice_number}
                                        </div>
                                        <div className="mt-2">
                                            <h2 className="bold">Reference</h2>
                                            {invoiceData?.ref_id}
                                        </div>
                                        <div className="mt-2">
                                            <h2 className="bold">ABN</h2>
                                            21 168 539 017
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <p className="mt-2">ReadyTeacher Pty Ltd</p>
                                        <p className="mt-2">finance@readyteacher.com.au</p>
                                        <p className="mt-2">Queries: 1800 READYT (1800 732 398)</p>
                                        {
                                            invoiceData?.invoice_url ? 
                                            (<button type="button" className={`btn mt-2 mb-2 btn-primary`} onClick={() => window.open(invoiceData?.invoice_url, "_blank")}>Invoice Link</button>)
                                            : ''
                                        }
                                    </div>
                                </div>

                                <div className="row table-row">
                                    {!isLoading ? (data?.length > 0 ? <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th className="text-center" style={{ "width": '5%' }}>Item #</th>
                                                <th style={{ "width": '35%' }}>Description</th>
                                                <th className="text-right" style={{ "width": '10%' }}>No. of Hours</th>
                                                <th className="text-right" style={{ "width": '5%' }}>Unit Price</th>
                                                {editingIndex !== -1 || totalReasons > 0 ? <th style={{ "width": '30%' }}>Variation Reason</th> : ''}
                                                <th className="text-right" style={{ "width": '5%' }}>GST Applied</th>
                                                <th className="text-right" style={{ "width": '5%' }}>Discount</th>
                                                <th className="text-right" style={{ "width": '5%' }}>Amount AUD</th>
                                                <th className="text-right" style={{ "width": '20%' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.length > 0 && data?.map((item, index) => (
                                                <tr id={index} className={index === data.length - 1 ? 'last-row' : ''}>
                                                    <td className="text-center">{item?.itemNumber}</td>
                                                    <td>{editingIndex === index ? <>

                                                        {item.description} {!item.non_teaching ? item?.dateBookings.map((value, index) => (
                                                            <div className="row">
                                                                <FormDatePicker
                                                                    id="from_date"
                                                                    placeholderText="Select date"
                                                                    popperClassName="some-custom-class"
                                                                    showPopperArrow={false}
                                                                    className="form-field col-md-4"
                                                                    dropdownMode="select"
                                                                    dateFormat="DD-MM-YY"
                                                                    value={moment(value.startDate, "DD-MM-YY").format("DD-MM-YY")}
                                                                    onChange={(date) => changeFromDate(date, index)}
                                                                /> to
                                                                <FormDatePicker
                                                                    id="from_date"
                                                                    placeholderText="Select date"
                                                                    popperClassName="some-custom-class"
                                                                    showPopperArrow={false}
                                                                    dropdownMode="select"
                                                                    className="form-field col-md-4"
                                                                    dateFormat="DD-MM-YY"
                                                                    value={moment(value.endDate, "DD-MM-YY").format("DD-MM-YY")}
                                                                    onChange={(date) => changeToDate(date, index)}
                                                                />
                                                                <div className="flex align-items-center ml-2 form-field">
                                                                    <p>
                                                                        {
                                                                            value.levelBooking?.split("_id:")?.[0] ? value.levelBooking?.split("_id:")?.[0] : value.levelBooking
                                                                        }
                                                                    </p>
                                                                    <IconButton variant="outlined" size="small" onClick={() => handlePopupLevel(index, value.levelBooking)}>
                                                                        <ModeIcon />
                                                                    </IconButton>
                                                                </div>
                                                            </div>
                                                        )) : item?.dateBookings.map(value => (
                                                            value.startDate + " to " + value.endDate + " " + (value.levelBooking?.split("_id:")?.[0] ? value.levelBooking?.split("_id:")?.[0] : value.levelBooking)
                                                            + " "
                                                        ))} {(item?.preCode ? "- " : "") + item.preCode}
                                                        {
                                                            !item.non_teaching && !invoiceBookingFees.includes(item.description) ?
                                                                <button onClick={() => addRow(index, item)} className="btn btn-block secondary-button-no-margin-hover btn btn-secondary d-block">
                                                                    Add non-teaching hours
                                                                </button>
                                                                : ''
                                                        }
                                                    </> :
                                                        <>
                                                            {
                                                                (item.is_edit?.description == true) && !item?.non_teaching ? <p>
                                                                    <del>
                                                                        {
                                                                            invoiceData && invoiceData?.previous_content[index]?.description +
                                                                            invoiceData?.previous_content[index]?.dateBookings.map(value => (
                                                                                value.startDate + " to " + value.endDate + " " +
                                                                                (value.levelBooking?.split("_id:")?.[0] ? value.levelBooking?.split("_id:")?.[0] : value.levelBooking) + " "
                                                                            )) + (item?.preCode ? "- " : "") + item.preCode
                                                                        }
                                                                    </del>
                                                                </p>
                                                                    : ''
                                                            }
                                                            {
                                                                item.description + item?.dateBookings.map(value => (
                                                                    value.startDate + " to " + value.endDate + " " +
                                                                    (value.levelBooking?.split("_id:")?.[0] ? value.levelBooking?.split("_id:")?.[0] : value.levelBooking) + " "
                                                                )) + (item?.preCode ? "- " : "") + item.preCode
                                                            }
                                                        </>
                                                    }
                                                        <p className="text-status-color">{item.comment_by_admin ? item?.comment_by_admin?.description : ''}</p>
                                                    </td>
                                                    <td className="text-right">{editingIndex === index && !invoiceBookingFees.includes(item.description) ?
                                                        <textarea onChange={(e) => {
                                                            const preState = [...data];
                                                            let object = { ...preState[editingIndex] };
                                                            object.quantity = Number(e.target.value);
                                                            object.is_edit.quantity = true;
                                                            preState[editingIndex] = object;
                                                            handleCalculatePriceInvoice(preState);
                                                            setData(preState);
                                                        }} className="form-control mb-0 p-2">{item.quantity}
                                                        </textarea> :
                                                        <>
                                                            {
                                                                item.is_edit?.quantity == true && !item?.non_teaching && invoiceData ? <p className="text-right">
                                                                    <del>{invoiceData?.previous_content[index]?.quantity}</del>
                                                                </p> : ''
                                                            }
                                                            {
                                                                item.quantity
                                                            }
                                                        </>
                                                    }
                                                        <p className="text-status-color text-right">{item.comment_by_admin ? item?.comment_by_admin?.quantity : ''}</p>
                                                    </td>
                                                    <td className="text-right">{'$' + item.unit_amount.toFixed(2)}</td>
                                                    {(editingIndex !== -1 || totalReasons > 0) ? <td>{editingIndex === index && !item.non_teaching ?
                                                        <FormDropdown
                                                            className="row"
                                                            onChange={(e) => {
                                                                const preState = [...data];
                                                                let object = { ...preState[editingIndex] };
                                                                object.reason = e.target.value;
                                                                object.is_edit.reason = true;
                                                                preState[editingIndex] = object;
                                                                if (e.target.value !== '') {
                                                                    setTotalReasons(1);
                                                                }
                                                                setData(preState);
                                                            }}>
                                                            <option value=''>
                                                                {
                                                                    invoiceBookingFees.includes(item?.description) ?
                                                                        'Request discount reason' : 'Select a reason'
                                                                }
                                                            </option>
                                                            {
                                                                invoiceBookingFees.includes(item.description) ?
                                                                    invoiceBookingFeesReason.map(reason => {
                                                                        return <option selected={item?.reason === reason.value} value={reason.value} key={reason.value}>
                                                                            {reason.description}
                                                                        </option>
                                                                    })
                                                                    : invoiceVariationReasons?.map((reason) => {
                                                                        return <option selected={item?.reason === reason.value} value={reason.value} key={reason.value}>
                                                                            {reason.description}
                                                                        </option>
                                                                    })
                                                            }
                                                        </FormDropdown> : (
                                                            invoiceBookingFees.includes(item.description) ?
                                                                invoiceBookingFeesReason.map(reason => {
                                                                    return item?.reason === reason.value ? reason.description : ''
                                                                })
                                                                : invoiceVariationReasons?.map((reason) => {
                                                                    return item?.reason === reason.value ? reason.description : ''
                                                                })
                                                        )}</td> : ''}
                                                    <td className="text-right">{item.tax_type === 'GST on income' ? '10%' : 'GST Free'}</td>
                                                    <td className="text-right">{ item?.discount && item?.discount != 0 ? '%' + item?.discount : ''}</td>
                                                    <td className="text-right">{'$' + parseFloat(Math.floor((item.quantity * item.unit_amount - (item?.discount ? (item.unit_amount * item.quantity) * item?.discount / 100 : 0)) * 100) / 100).toFixed(2)}</td>
                                                    <td>
                                                        {(!item?.mark_as_done && (invoiceData?.status !== 'Approved by customer' && invoiceData?.status !== 'Paid')) ? (editingIndex === index ? (
                                                            <div className="row">
                                                                <button onClick={() => handleUpdateMode(editingIndex)} className="btn submit-revision mb-2">Submit revision</button>
                                                                <button onClick={handleCancelEdit} className="btn edit-revision mb-2">Cancel</button>
                                                            </div>
                                                        ) : (
                                                             (
                                                                <div className="row">
                                                                    <button onClick={() => handleEditingMode(index)} className="btn edit-revision mb-2">Edit item</button>
                                                                    {(item.is_edit?.description == true || item?.is_edit?.quantity == true || item?.is_edit?.reason == true) ? <p className="text-secondary text-center m-2">Under Review</p> : <button onClick={() => handleMarkAsDone(index)} className="btn submit-revision mb-2">Mark done</button>}
                                                                </div>
                                                            )
                                                        )) : ''}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table> : <p>No invoice rows to display</p>)
                                        : <Spinner small />}
                                </div>

                                <div className="row">
                                    <div className="col-6 margintop">
                                    </div>
                                    <div className="col-6 text-right pull-right invoice-total">
                                        <p className="text-right">Subtotal ${parseFloat(subTotal).toFixed(2)}</p>
                                        <p className="text-right">Total GST ${parseFloat(totalGST).toFixed(2)} </p>
                                        <h3>
                                            <p className="text-right bold">Total AUD ${parseFloat(subTotal + totalGST).toFixed(2)} </p>
                                        </h3>
                                    </div>
                                </div>
                                {
                                    editingIndex !== -1 || commentRevision !== "" ?
                                        <div className="row">
                                            <div className="col-6"></div>
                                            <div className="col-6">
                                                <div>
                                                    <label htmlFor="commentRevision">Comments to accompany revision request:</label>
                                                    <textarea className="form-control mb-0 p-2" id="commentRevision" rows="3"
                                                        onChange={(e) => {
                                                            setCommentRevision(e.target.value);
                                                        }} value={commentRevision}></textarea>
                                                </div>
                                                <div className="pt-2 d-flex justify-content-end">
                                                    <button className="pt-2 btn btn-primary" onClick={handleAddComment}>SUBMIT</button>
                                                </div>
                                            </div>
                                        </div>
                                        : ''
                                }
                                <div className="row">
                                    <div className="col-4 mt-3">
                                        <button disabled={isDisabledButton} className={`btn btn-info m-2`} onClick={handleDownloadPDF}>
                                            <i className="fa fa-download"></i>
                                            Download PDF
                                        </button>
                                    </div>
                                    <div className="col-8 d-flex justify-content-end mt-3">
                                        {
                                            editedStatus && !invoiceData?.paid_datetime ? <p className="m-3">Under review by ReadyTeacher admin. Unable to approve.</p> : ''
                                        }
                                        {!user?.personnel_id || !invoiceData?.paid_datetime ? '' : <button type="button" disabled={editedStatus || invoiceData?.status == 'Approved by customer' || invoiceData?.status == 'Paid'} className={`mt-2 mb-2 btn btn-secondary ${editedStatus ? 'buttonDisabled' : ''}`} onClick={() => setIsOpenPopupApproved(true)}> Approve & Pay</button>}
                                        {!invoiceData?.paid_datetime && (user?.payment_settings !== 'option-finance-team' || !invoiceData?.pn_view) ? <button type="button" disabled={editedStatus || invoiceData?.status == 'Approved by customer' || invoiceData?.status == 'Paid'} className={`btn mt-2 mb-2 btn-primary ${editedStatus ? 'buttonDisabled' : ''}`} onClick={() => setIsOpen(true)}> Approve & Forward for payment</button> : ''}
                                        {invoiceData?.paid_datetime ?
                                            <div>
                                                <p className="bold">Paid Date: {moment(invoiceData?.paid_datetime, 'YYYY/MM/DD HH:mm').tz('Australia/Melbourne').format('DD/MM/YYYY HH:mm')} </p>
                                            </div>
                                            : ''}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CollegePageContainer>
    );
}
